import apiClient from './ApiService'

export default {
  getTiposCobroCuota(page = 1, limit = 100, filters = {}) {
    return apiClient.get('/tipos-cobro-cuota', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getAllTiposCobroCuota(filters = {}) {
    return apiClient.get('/tipos-cobro-cuota/all', {
      params: filters
    })
  },
  
  getTipoCobroCuota(id) {
    return apiClient.get(`/tipos-cobro-cuota/${id}`)
  },
  
  createTipoCobroCuota(tipoCobroCuota) {
    return apiClient.post('/tipos-cobro-cuota', tipoCobroCuota)
  },
  
  updateTipoCobroCuota(id, tipoCobroCuota) {
    return apiClient.put(`/tipos-cobro-cuota/${id}`, tipoCobroCuota)
  },
  
  deleteTipoCobroCuota(id) {
    return apiClient.delete(`/tipos-cobro-cuota/${id}`)
  }
}